/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['div[_ngcontent-%COMP%]{margin-bottom:10px}md-button-toggle.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#3c990f;transition:.4s;color:#fff}md-button-toggle-group.ng-invalid.ng-touched[_ngcontent-%COMP%]{border-bottom:1px solid red}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL3llcy1uby1maWVsZC95ZXMtbm8tZmllbGQuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvZmllbGRzL2NvbXBvbmVudHMveWVzLW5vLWZpZWxkL3llcy1uby1maWVsZC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/yes-no-field/yes-no-field.component.scss.shim.ngstyle.ts